import React from 'react';
import { Link } from 'gatsby';
import marked from 'marked';

import CDNImage from '../../components/common/cdn-image';
import { ShoppingBagSvg } from '../../components/common/svg';

import '../../styles/collections/top-embed.scss';

const buildImage = (data) => {
    const pathRegex = /path={([\S]+)}/;
    let imgPath = '';
    if (data.match(pathRegex)) {
        imgPath = data.match(pathRegex)[1];
    }


    const captionRegex = /caption={([\s\S]*?)}/;
    let caption = '';
    if (data.match(captionRegex)) {
        caption = data.match(captionRegex)[1];
    }

    const altRegex = /alt={([\s\S]+?)}/;
    let alt = '';
    if (data.match(altRegex)) {
        alt = data.match(altRegex)[1];
    }

	const widthRegex = /width={([\s\S]+?)}/;
	let width = null;
	if (data.match(widthRegex)) {
		width = data.match(widthRegex)[1];
	}
	
    const animatedGifRegex = /animatedGif={([\s\S]+?)}/;
    let noProcessing = false;
    if (data.match(animatedGifRegex)) {
        noProcessing = true;
    }

    const flexibleHeightRegex = /flexibleHeight={([\s\S]+?)}/;
    let flexibleHeight = false;
    if (data.match(flexibleHeightRegex)) {
        flexibleHeight = true;
    }

    const clickThruRegex = /clickThru={([\s\S]+?)}/;
    let clickThru = '';
    if (data.match(clickThruRegex)) {
        clickThru = data.match(clickThruRegex)[1];
    }

    const printRegex = /print={([\s\S]+?)}/;
    let print = '';
    if (data.match(printRegex)) {
        print = data.match(printRegex)[1];
    }

    const imageContents = (
        <>
        <CDNImage imagePath={imgPath} alt={alt} fit={'max'} width={width ? width : 1200} height={ flexibleHeight ? null : 850  } flexibleHeight={ flexibleHeight } noProcessing={ noProcessing } showUndownloadedMessage={ false } />
        {(print.length > 0) ? (
            <Link
                to={`/product/${print}?utm_source=pdr&utm_medium=inpost&utm_campaign=prints&utm_content=pic`}
                className="image__buy-a-print"
            >
                { ShoppingBagSvg }
                {' '}
                <span className="label">Buy as a Print</span>
            </Link>
        ) : null}
    </>
    );
    if (imgPath) {
        return (
          <div>
            <div className="image-block">
              {(clickThru.length > 0) ? (
                <a href={ clickThru }>{imageContents}</a>
              ) : (
                <>{imageContents}</>
              )}
            </div>
            {(caption.length > 0) ? (
              <p
                className="label"
                dangerouslySetInnerHTML={{ __html: marked(caption).replace('<p>', '').replace('</p>', '') }}
              />
            ) : null}
          </div>
    );
  }

  return null;
};

const processContent = (data) => {
  const imageRegex = /{image[\s\S]+?endimage}/g;
  const textContent = data.split(imageRegex);

  let imageMatches = []
  let m;
  do {
    m = imageRegex.exec(data);
    if (m) {
      imageMatches.push(m);
    }
  } while (m);

  const images = Array.from(imageMatches).map(match => match[0]);

  let contentBlocks = [];
  for (let i = 0; i < textContent.length; i++) {
    if (textContent[i].length > 0) {
      contentBlocks.push(<div dangerouslySetInnerHTML={{ __html: textContent[i] }} />);
    }
    if (i < textContent.length - 1) {
      contentBlocks.push(buildImage(images[i]));
    }
  }

  return contentBlocks;
};

const TopEmbed = (props) => {
  const contentBundles = processContent(props.data);

  return (
    <div className="collection__featured-embed">
      {contentBundles.map(bundle => bundle)}
    </div>
  );
};

export default TopEmbed;
